import { useGlobalContext } from "../context/GlobalProvider";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";

export const Devtools = () => {
  const { devtoolsRef } = useGlobalContext();

  if (!import.meta.env.DEV) {
    return null;
  }

  return (
    <div ref={devtoolsRef} style={{ pointerEvents: "auto" }}>
      <ReactQueryDevtools
        initialIsOpen={false}
        buttonPosition="bottom-left"
        position="bottom"
      />
      <TanStackRouterDevtools position="top-left" />
    </div>
  );
};
